'use client'

import { cn } from '@/lib/utils'
import Image from 'next/image'
import { imageUrl } from '@/lib/utils'
import { ImageFragmentFragment } from '@/api'

type Props = {
  src: ImageFragmentFragment
  active: boolean
  onClick: () => void
  id: string
}

export default function Thumbnail({ src, active, onClick, id }: Props) {
  return (
    <Image
      id={id}
      src={imageUrl(src)}
      alt="shoes"
      width={0}
      height={0}
      onClick={onClick}
      className={cn(
        'aspect-[1/1] w-1/5 cursor-pointer',
        active && 'border-b-2 lg:border-b-3 border-black'
      )}
    />
  )
}
